import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[appTooltipIfCollapsed]',
  standalone: false
})
export class TooltipIfCollapsedDirective implements AfterViewInit {

  constructor(
    private el: ElementRef<HTMLElement>,
    private tooltip: MatTooltip
  ) { }

  ngAfterViewInit(): void {
    // Initial check once DOM is ready
    window.requestAnimationFrame(() => this.updateTooltip());
  }

  @HostListener('mouseenter')
  @HostListener('window:resize')
  onTrigger(): void {
    // Defer to next frame so scrollWidth is correct
    window.requestAnimationFrame(() => this.updateTooltip());
  }

  private updateTooltip(): void {
    const elem = this.el.nativeElement;
    const isOverflowing = elem.scrollWidth > elem.offsetWidth;
    // console.log('elem', elem);
    // console.log('elem.scrollWidth', elem.scrollWidth);
    // console.log('elem.offsetWidth', elem.offsetWidth);

    // enable only when overflowing
    this.tooltip.disabled = !isOverflowing;
    if (isOverflowing) {
      // ensure tooltip shows full content
      this.tooltip.message = elem.textContent?.trim() ?? '';
    }
  }

}
